import './referral-setting.scss';

import { Outlet } from "react-router-dom";

import { FilterReferralSettingProvider } from "./filter-referral-setting/filter-referral-setting.context";

export function ReferralSetting() {
  return (
    <div id="ShellReferralSetting" className="referral-setting">
       <FilterReferralSettingProvider>
        <Outlet />
      </FilterReferralSettingProvider>
    </div>
  );
}

export default ReferralSetting;
